import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { toast } from 'react-toastify';

export const LikeButton = ({activity, type})=> {
    const auth = useSelector(state => state.auth);

    const likeMutate = useMutation({
        mutationFn:(data) => Api.get(`/api/like/toggle/${data.type}/${data.id}`),
        onSuccess:(res)=>{
            activity.likeCount = res.data?.likeCount;
            activity.likeCheck = res.data?.likeCheck;
            // activity만 변경되어도 잘 적용되넹?
            // queryClient.invalidateQueries(queryKey);
        },
        onError:(err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    });
    
    

    const onToggleLike = ()=>{
        if(likeMutate.isPending)return;
        if (!auth.authenticated) return;
        if (auth.id === activity.user?.id || auth.id === activity.userId) return;
        likeMutate.mutate({type, id:activity.id});
    }
    if(activity===undefined)return;
    if (activity === null || activity?.deleteYn === "Y") return;
    let active = activity.likeCheck ? "on" : "";

    // 기존활동
    if(type==="userbookEpisode"){
        return (
            <button className={`btn _sm ${activity.likeCheck?'_pink':'light_gray'}`} onClick={onToggleLike}>
                <i className="far fa-heart"> {activity.likeCount}</i>
            </button>
        )
    }else if(type==='dongwhaStory'){
        return (
            <button className={`btn _white ${activity.likeCheck && '_pink'}`} onClick={onToggleLike}>
                <i className="fa-regular fa-thumbs-up"></i>좋아요 {activity.likeCount}
            </button>
        );
    }


    return (
        <button type="button" className={`like_btn ${active}`} onClick={onToggleLike}>
            <span>
                <i className="icon far fa-thumbs-up"></i>
            </span>
            {activity.likeCount}
        </button>
    );
};